import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NavbarIconsConfiguration from "../generic-nav-bar/NavbarIconsConfiguration";
import SearchBackConfiguration from "../generic-search/SearchBackConfiguration";
import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";

import { useTranslation } from "react-i18next";
import { useTracking } from "react-tracking";
import { cleanSearchingConfigurationsPaginated, configurationCleanSearchText, configurationStartDelete, selectConfigurations, startLoadingConfigurationsPaginated, startSearchingConfigurationsPaginated } from "../../app/actions/configurationActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import TableConfigurations from "./TableConfigurations";

const ID_FORM = "admin-configuration";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListConfigurations = () => {
  debugLogPages(':: ListConfigurations');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, configurationsS, configurationsP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.configuration);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingConfigurationsPaginated());
    dispatch(configurationCleanSearchText());
    //Load Data
    dispatch(startLoadingConfigurationsPaginated(pageInitial, itemsPerPage));
    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditConfigurations", method: "onEditRow", event: "EditConfigurations-Clicked" });

    dispatch(selectConfigurations(row));
    if (configurationsS && configurationsS.length > 0) {
      navigate("/admin-configuration/edit-configuration", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-configuration/edit-configuration");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteConfigurations", method: "onDeleteRow", event: "DeleteConfigurations-Clicked" });
    dispatch(configurationStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {

    if (configurationsS && configurationsS.length > 0) {
      dispatch(startSearchingConfigurationsPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingConfigurationsPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (configurationsS && configurationsS.length > 0) {
      dispatch(startSearchingConfigurationsPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingConfigurationsPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

   debugLogPages(':: ListConfigurations', { configurationsP });

  return (
    <>
      <NavbarIconsConfiguration page={"listConfiguration"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackConfiguration searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {configurationsS && configurationsS.length > 0 ? (
        <TableConfigurations data={configurationsS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableConfigurations data={configurationsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {configurationsS && configurationsS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListConfigurations;
